export default "__VITE_ASSET__pwIEiCK$__"